import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  HomeEnglish,
  HomeArabic,
  Courses,
  ContactUs,
  Error,
  SingleCourse,
} from "./pages";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeEnglish />} />
        <Route path="/arabic" element={<HomeArabic />} />
        <Route path="/courses" element={<Courses />} />
        <Route exact path="/courses/:id" element={<SingleCourse />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route exact path="/*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
